import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PersonResumeTemplateProps {
  readonly personName: string;
  readonly children: ReactNode;
}

export function PersonResumeTemplate({ personName, children }: PersonResumeTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>

        <BreadcrumbLink>
          <Link to="/persons">{t('breadcrumb.persons')}</Link>
        </BreadcrumbLink>

        <BreadcrumbPage>{t('breadcrumb.resume')}</BreadcrumbPage>
      </Breadcrumb>

      <div className="flex flex-col gap-nano mb-xxs">
        <h1 className="ts-heading-lg text-ctx-content-title">{t('resumePage.title')}</h1>
        <p className="ts-paragraph-xs text-ctx-content-title">{personName}</p>
      </div>

      {children}
    </div>
  );
}
